import { walletService } from '@/services/api'
import { groupByArrayOfObject } from '@/common/arrays'

const initialStates = {
    status: 'LOADING',
    walletsList: {},
    checkoutList: {},
    pagination: {
        no_paginate: false,
        per_page: 20,
        current_page: 1,
        last_page: 1,
    },
    params: {
        page: 1
    }
}

const mutations = {
    loading(state) {
        state.status = 'LOADING'
    },
    setWalletsList(state, wallets) {
        state.status = 'SET_LIST'
        state.walletsList = wallets
    },
    setCheckoutList(state, checkoutList) {
        state.status = 'SET_CHECKOUT_LIST'
        state.checkoutList = checkoutList
    },
    setPagination(state, pagination) {
        state.status = 'SET_PAGINATION'
        state.pagination = Object.assign({}, state.pagination, pagination)
    },
    setParams(state, params) {
        state.status = 'SET_PARAMS'
        state.params = Object.assign({}, state.params, params)
    },
    error(state) {
        state.status = 'ERROR'
    },
}

const getters = {
    wallets: state => state.walletsList,
    checkoutList: state => state.checkoutList,
    pagination: state => state.pagination,
}

const actions = {
    setParamsAndFetch({ dispatch }, params) {
        dispatch('setParams', params)
        dispatch('fetch')
    },
    setParams({ commit }, params) {
        commit('setParams', params)
    },
    resetParams({ commit }) {
        commit('resetParams')
    },
    fetch({ commit, state }, params) {
        params = Object.assign({}, state.params, params)
        commit('loading')

        return new Promise((resolve, reject) => {
            walletService.fetch(params)
                .then(response => {
                    const result = response.data
                    const wallets = groupByArrayOfObject(result.data, 'id')

                    commit('setWalletsList', wallets)
                    commit('setPagination', {
                        per_page: result.per_page,
                        current_page: result.current_page,
                        last_page: result.last_page,
                        no_paginate: false,
                    })
                    commit('setParams', {
                        page: result.current_page,
                    })
                    resolve(result)
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? error.response.data : error.response)
                })
        })
    },
    publishersCheckoutList({ commit, state }, params) {
        params = Object.assign({}, state.params, params)
        commit('loading')

        return new Promise((resolve, reject) => {
            walletService.checkoutList(params)
                .then(response => {
                    const result = response.data
                    const checkoutList = groupByArrayOfObject(result.data, 'id')

                    commit('setCheckoutList', checkoutList)
                    commit('setPagination', {
                        no_paginate: true,
                    })
                    resolve(result)
                })
                .catch(error => {
                    commit('error')
                    reject(error.response ? error.response.data : error.response)
                })
        })
    },
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}